PJQ.models.drawings.Version = PJQ.models.BaseModel.extend({
    idAttribute: 'versionId',
    notifyName: 'Version',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'versions',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        this.drawings = new PJQ.collections.drawings.Drawings(model.drawings);
        this.listenTo(this.drawings, 'change', _.bind(function () {
            this.trigger('change');
        }, this));
        return model;
    },
    beforeSave: function () {
        this.set('drawings', this.drawings.getChangedModels());
    },
    download: function () {
        PJQ.files.queueDownload(this.endpoint() + '/download');
    },
    getDrawingTags: function () {
        let tags = [];
        _.each(this.drawings.models, function (drawing) {
            let drawingTags = drawing.get('tags');
            if (_.size(drawingTags) > 0) {
                tags.push(...drawingTags);
            }
        });
        return _.uniq(tags);
    }
});

PJQ.models.drawings.DrawingBatch = PJQ.models.BaseModel.extend({
    idAttribute: 'batchId',
    notifyName: 'Batch',
    defaults: {
        isFileAPI: true
    },
    endpoint: function (urlOpts) {
        if (this.id > 0) {
            let params = null;
            if (urlOpts && urlOpts.publish) {
                params = [
                    {
                        parameter: 'publish',
                        value: true
                    }
                ];

                if (urlOpts.billRawFileUploadId) {
                    params.push({
                        parameter: 'billRawFileUploadId',
                        value: urlOpts.billRawFileUploadId
                    });
                }
                if (urlOpts.billDeerfieldTicketId) {
                    params.push({
                        parameter: 'billDeerfieldTicketId',
                        value: urlOpts.billDeerfieldTicketId
                    });
                }

            } else if (urlOpts && urlOpts.revert) {
                params = [
                    {
                        parameter: 'revert',
                        value: true
                    }
                ];
            }

            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'batches',
                    value: this.id
                }
            ], params);
        } else if (_.size(this.files.models) > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'versions',
                    value: this.version.id
                },
                {
                    endpoint: 'filebatch'
                },
            ], [
                {
                    parameter: 'entryList',
                    value: _.map(this.files.models, function (file) {
                        return file.get('entryId');
                    }).join(',')
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'batches',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model != null) {
            if (model.createdBy != null) {
                this.createdBy = new PJQ.models.users.User(model.createdBy);
            }

            if (model.version != null) {
                this.version = new PJQ.models.drawings.Version(model.version);
            }
        }

        this.files = new PJQ.collections.files.Files(model.files);
        this.uploads = new PJQ.collections.drawings.Drawings(model.uploads);
        this.drawings = new PJQ.collections.drawings.Drawings(model.drawings);
        return model;
    },
    fetchStatus: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'batches',
                    value: this.get('guid')
                },
                {
                    endpoint: 'status'
                }
            ])
        }).get().done(_.bind(function (data) {
            this.set('status', data.status);
            callback(data.status);
        }, this));
    },
    beforeSave: function () {
        if (this.version != null) {
            this.set('versionId', this.version.id);
        }

        this.set('files', this.files.getChangedModels());
        this.set('uploads', this.uploads.getChangedModels());
        this.set('drawings', this.drawings);
    }
});

PJQ.models.drawings.DrawingBatchNotification = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'batches',
                value: this.get('batchId')
            },
            {
                endpoint: 'notify',
                value: this.id
            }
        ]);
    },
    beforeSave: function () {

    }
});

PJQ.models.drawings.Drawing = PJQ.models.files.File.extend({
    idAttribute: 'drawingId',
    endpoint: function (urlOpts) {
        let params = [];
        if (urlOpts && urlOpts.currentSet != null) {
            params = [
                {
                    parameter: 'currentSet',
                    value: urlOpts.currentSet
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings',
                value: _.size(this.get('guid')) > 0 ? this.get('guid') : this.id
            }
        ], params);
    },
    download: function (withAnnotations = false, context = null, contextId = null) {
        let downloadUrl = this.endpoint() + '/download';
        if (PJQ.app.session.project != null) {
            downloadUrl = "/projects/" + PJQ.app.session.project.id.toString() + "/" + downloadUrl
        }

        if (withAnnotations) {
            downloadUrl += "?annotations=true&_=" + PJQ.helpers.guid();

            if (_.size(context) > 0 && contextId > 0) {
                downloadUrl = downloadUrl + (downloadUrl.indexOf("?") === -1 ? "?" : "&") + "context=" + context + "&contextId=" + contextId.toString();
            }
        }

        PJQ.files.downloadFile(downloadUrl, {
            isApi2: true,
            includeAccessKey: true
        });
    },
    thumbUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/thumbnail?r=" + this.get('rotation').toString();
    },
    cropUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/crop?r=" + this.get('rotation').toString() + '&g=' + PJQ.helpers.guid();
    },
    cropNameUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/cropname?r=" + this.get('rotation').toString() + '&g=' + PJQ.helpers.guid();
    },
    cropTitleUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/croptitle?r=" + this.get('rotation').toString() + '&g=' + PJQ.helpers.guid();
    },
    renderUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/render?r=" + this.get('rotation').toString();
    },
    rotate: function (degrees, callback) {
        let curRotation = this.get('rotation'),
            newRotation = (curRotation ? curRotation : 0) + degrees;
        if (newRotation >= 360) {
            newRotation = newRotation -= 360;
        } else if (newRotation < 0) {
            newRotation = newRotation += 360;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings',
                    value: this.get('guid')
                },
                {
                    endpoint: 'rotate'
                }
            ], [
                {
                    parameter: 'degrees',
                    value: degrees
                }
            ]),
            isApi2: true
        }).post().done(_.bind(function (data) {
            this.set({
                rotation: newRotation
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    addTags: function (tags, options, callback) {
        let newTags = _.difference(tags, this.get('tags')),
            fnAdd = _.bind(function () {
                this.get('tags').push(...newTags);
                this.trigger("change");
                if (typeof callback === 'function') {
                    callback(newTags);
                }
            }, this);
        if (options == null || options.save !== false) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings',
                        value: this.id
                    },
                    {
                        endpoint: 'tags'
                    }
                ], [
                    {
                        parameter: 'tags',
                        value: newTags.join(',')
                    }
                ])
            }).post().done(_.bind(function () {
                fnAdd();
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            fnAdd();
        }
    },
    deleteTag: function (name, options, callback) {
        let fnDelete = _.bind(function () {
            this.set('tags', _.without(this.get('tags'), name));
            this.trigger("change");
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this);

        if (options == null || options.save !== false) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings',
                        value: this.id
                    },
                    {
                        endpoint: 'tags'
                    }
                ], [
                    {
                        parameter: 'name',
                        value: name
                    }
                ])
            }).delete().done(_.bind(function () {
                fnDelete();
            }, this)).fail(function () {
                callback(false);
            });
        } else {
            fnDelete();
        }
    },
    fetchAnnotations: function (options, callback) {
        if (this.annotations != null && options.context == this.annotations.options.context && options.contextId == this.annotations.options.contextId) {
            callback(this.annotations);
            return;
        }

        this.annotations = new PJQ.collections.drawings.Annotations(null, {
            drawingId: this.id,
            context: options != null ? options.context : null,
            contextId: options != null ? options.contextId : null,
            accessKey: options != null ? options.accessKey : null
        });
        this.annotations.fetch({
            success: _.bind(function () {
                callback(this.annotations);
            }, this)
        });
    },
    updateScale: function (scale, scaleType, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings',
                    value: this.id
                }
            ], [
                {
                    parameter: 'scale',
                    value: scale
                },
                {
                    parameter: 'scaleType',
                    value: scaleType
                }
            ])
        }).put().done(_.bind(function () {
            this.set({
                scale: scale,
                scaleType: scaleType
            });
            callback(true);
        }, this)).fail(function () {
            callback(false);
        });
    }
});

PJQ.collections.drawings.Versions = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.drawings.Version,
    endpoint: function () {
        if (_.size(this.options.accessKey) > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'share',
                    value: this.options.accessKey
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'versions'
            }
        ]);
    },
    getDrawing: function (drawingId) {
        let result = null;
        _.each(this.models, function (version) {
            let drawing = _.find(version.drawings.models, function (drawing) {
                return drawing.id === drawingId;
            });
            if (drawing != null) {
                result = drawing
            }
        });
        return result;
    },
    getDrawingCount: function () {
        let result = 0;
        _.each(this.models, function (version) {
            result += _.size(version.drawings.models);
        });
        return result;
    },
    getVersionStatsForDrawing: function (drawing) {
        // total starts at 1 because the code below will not match on "own version"
        // drawings have to belong to at least 1 version, so it starts at 1
        let result = {
                older: 0,
                newer: 0,
                total: 1,
                same: false,
                hide: false
            },
            ownVersion = this.get(drawing.get('versionId'))
        if (ownVersion == null) {
            result.hide = true;
        } else {
            let ownIssued = new Date(ownVersion.get('issuedOn')),
                ownCreated = new Date(ownVersion.get('createdOn'));
            _.each(this.models, function (version) {
                if (version.id > 0 && version.drawings.find(function (verDrawing) {
                    return drawing.get('name') === verDrawing.get('name') && verDrawing.id !== drawing.id;
                }) != null) {
                    result.total++;
                    if (version.id === ownVersion.id) {
                        result.same = true;
                    } else {
                        let thisIssued = new Date(version.get('issuedOn'));
                        if (thisIssued > ownIssued) {
                            result.newer++;
                        } else if (thisIssued < ownIssued) {
                            result.older++;
                        } else {
                            let thisCreated = new Date(version.get('createdOn'));
                            if (thisCreated > ownCreated) {
                                result.newer++;
                            } else if (thisCreated < ownCreated) {
                                result.older++;
                            }
                        }
                    }
                }
            });
        }
        return result;
    },
    findVersionsForDrawing: function (drawing, includeOwnVersion = true) {
        return _.filter(this.models, function (version) {
            return (includeOwnVersion || (!includeOwnVersion && version.id !== drawing.get('versionId'))) && version.drawings.findWhere({name: drawing.get('name')}) != null;
        }, this);
    },
    getDrawingTags: function () {
        let result = [];
        _.each(this.models, function (version) {
            result.push(...version.getDrawingTags());
        });
        return result;
    },
    getUniqueDrawings: function (excludeVersion) {
        let foundNames = [],
            fullSet = [];
        _.each(this.models, _.bind(function (version) {
            if (excludeVersion != null && version.id === excludeVersion.id) {
                return;
            }

            _.each(version.drawings.models, _.bind(function (drawing) {
                let drawingName = drawing.get('name');
                if (foundNames.indexOf(drawingName) === -1) {
                    foundNames.push(drawingName);
                    fullSet.push(drawing);
                }
            }, this));
        }, this));
        return fullSet;
    },
    createPsuedoFolders: function (attachments) {
        let hasDrawings = false,
            drawingsFolderId = -parseInt(_.uniqueId()),
            drawingAttachments = [],
            tryHideCurrentSet = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_CURRENT_SET_WHEN_POSSIBLE),
            isHideCurrentSet = false;
        if (tryHideCurrentSet) {
            let versionsWithDrawings = _.filter(this.models, (version) => {
                return version.drawings.models.length > 0;
            });
            if (versionsWithDrawings.length <= 2) {
                let getDrawingNames = (version) => {
                        let drawingNames = [];
                        _.each(version.drawings.models, (drawing) => {
                            drawingNames.push(drawing.get('name'));
                        });
                        return drawingNames;
                    },
                    currentSet = this.get(-1);
                if (currentSet != null) {
                    let currentSetDrawingNames = getDrawingNames(currentSet);
                    isHideCurrentSet = null == _.find(versionsWithDrawings, (version) => {
                        if (version.id === -1) {
                            return false;
                        }
                        return version.id !== -1 && !_.isEqual(currentSetDrawingNames, getDrawingNames(version));
                    });
                }
            }
        }
        _.each(_.sortBy(this.models, function (version) {
            return new Date(version.get('issuedOn'));
        }), _.bind(function (version, index) {
            if (isHideCurrentSet && version.id === -1) {
                return;
            }

            if (_.size(version.drawings.models) > 0) {
                hasDrawings = true;

                let versionFolderId = -parseInt(_.uniqueId());
                drawingAttachments.push(new PJQ.models.projects.ProjectAttachment({
                    entryId: versionFolderId,
                    name: version.get('name'),
                    folderId: drawingsFolderId,
                    sortOrder: version.id === -1 ? -1 : index,
                    isFolder: true,
                    isDrawing: true,
                    versionId: version.id,
                    modifiedOn: version.get('createdOn')
                }));
                _.each(version.drawings.models, _.bind(function (drawing) {
                    drawingAttachments.push(new PJQ.models.projects.ProjectAttachment({
                        entryId: -parseInt(_.uniqueId()),
                        name: drawing.get('fileName'),
                        guid: drawing.get('guid'),
                        folderId: versionFolderId,
                        size: drawing.get('fileSize'),
                        url: drawing.get('url'),
                        drawingId: drawing.id,
                        isFolder: false,
                        isDrawing: true,
                        versionId: version.id,
                        sortOrder: drawing.get('sortOrder'),
                        modifiedOn: version.get('createdOn')
                    }));
                }, this));
            }
        }, this));
        if (_.size(drawingAttachments) > 0) {
            attachments.add(new PJQ.models.projects.ProjectAttachment({
                entryId: drawingsFolderId,
                name: "Drawings",
                folderId: 0,
                isFolder: true,
                isDrawing: true,
                modifiedOn: _.max(this.models, function (ver) {
                    return ver.id;
                }).get('createdOn'),
                sortOrder: -2
            }));
            attachments.add(drawingAttachments);
        }
        return attachments;
    },
    download: function () {

    },
    merge: function () {

    }
});

PJQ.collections.drawings.DrawingBatches = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.DrawingBatch,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'batches'
            }
        ]);
    }
});

PJQ.collections.drawings.Drawings = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.Drawing,
    endpoint: function (urlOptions) {
        let params = [];
        if (urlOptions.byName) {
            params.push({
                parameter: 'byName',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'drawings'
            }
        ], params);
    },
    share: function (versionIds, fileGuids, data, project, callback) {
        this.options.versionIds = versionIds;
        this.options.fileGuids = fileGuids;
        this.options.data = data;
        this.options.projectId = project ? project.id : null;

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'share'
            }
        ], [
            {
                parameter: 'allDrawings',
                value: this.options.allDrawings === true ? true : null
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                projectId: this.options.projectId,
                subject: data != null ? data.subject : null,
                emails: data != null ? data.emails : null,
                versionIds: this.options.versionIds,
                drawingGuids: _.map(this.models, function (model) {
                    return model.get('guid');
                }),
                guids: this.options.fileGuids
            }
        }).post().done(_.bind(function (data) {
            this.options.url = data.url;
            this.options.accessKey = data.accessKey;
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            callback();
        });
    },
    update: function (callback) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'share',
                value: this.options.accessKey
            }
        ], [
            {
                parameter: 'allDrawings',
                value: this.options.allDrawings === true ? true : null
            }
        ]);

        let data = this.options.data;
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                projectId: this.options.projectId,
                subject: data != null ? data.subject : null,
                emails: data != null ? data.emails : null,
                versionIds: this.options.versionIds,
                drawingGuids: _.map(this.models, function (model) {
                    return model.get('guid');
                }),
                guids: this.options.fileGuids
            }
        }).put().done(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }).fail(function () {
            callback();
        });
    }
});

PJQ.models.drawings.DrawingDownload = PJQ.models.files.File.extend({
    endpointArr: function () {
        return [
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'downloads',
                value: this.get('guid')
            }
        ];
    },
    cancel: function () {

    }
});

PJQ.collections.drawings.DrawingsShare = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.Drawing,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'share',
                value: this.options.accessKey
            }
        ]);
    }
});